export class LogicEvents {
	public static readonly INIT_RESPONSE: string = 'LogicEvents::INIT_RESPONSE';
	public static readonly SPIN_RESPONSE: string = 'LogicEvents::SPIN_RESPONSE';
	public static readonly FREE_SPIN_RESPONSE: string = 'LogicEvents::FREE_SPIN_RESPONSE';
	public static readonly RESPIN_RESPONSE: string = 'LogicEvents::RESPIN_RESPONSE';
	public static readonly AVALANCHE_RESPONSE: string = 'LogicEvents::AVALANCHE_RESPONSE';
	public static readonly PICK_RESPONSE: string = 'LogicEvents::PICK_RESPONSE';
	public static readonly SKIPPICK_RESPONSE: string = 'LogicEvents::SKIPPICK_RESPONSE';
	public static readonly SELECT_RESPONSE: string = 'LogicEvents::SELECT_RESPONSE';
	public static readonly PING_RESPONSE: string = 'LogicEvents::PING_RESPONSE';
	public static readonly ERROR_RESPONSE: string = 'LogicEvents::ERROR_RESPONSE';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/LogicEvents.ts